import { render, staticRenderFns } from "./ReleasesTimeline.vue?vue&type=template&id=b6bbc89c"
import script from "./ReleasesTimeline.vue?vue&type=script&lang=js"
export * from "./ReleasesTimeline.vue?vue&type=script&lang=js"
import style0 from "./ReleasesTimeline.vue?vue&type=style&index=0&id=b6bbc89c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports